<template>
  <div class="mx-auto container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-toolbar flat dense class="toolbar" v-if="isallowed">
      <v-toolbar-title>Serial Field Config</v-toolbar-title>
      <v-divider class="mx-4" inset vertical></v-divider>
    </v-toolbar>
    <v-app id="inspire" class="">
      <template v-if="load == true">
        <v-data-table
          :headers="headers"
          :items="serial_field_master_list"
          class="elevation-1 mytable"
          :search="search"
          dense
        >
          <template v-slot:top>
            <v-toolbar dense flat color="white">
              <!-- <v-toolbar-title>Serial Field Config</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider> -->
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              >
              </v-text-field>
              <span style="width: 20px"></span>
              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="button"
                    v-on="on"
                    @click="iseditable = !iseditable"
                    >New Config</v-btn
                  >
                </template>
                <v-card>
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-select
                            dense
                            rounded
                            outlined
                            v-model="editedItem.serialfieldtype"
                            :items="serial_field_type_list"
                            :readonly="editedIndex == -1 ? false : true"
                            item-text="serialfieldtype"
                            item-value="id"
                            label="Serial Field Type"
                            persistent-hint
                            :disabled="editedIndex != -1"
                            :hint="
                              iseditable
                                ? 'Select Type :: PRN No. etc'
                                : 'noneditable'
                            "
                            :filled="editedIndex == -1 ? false : true"
                            return-object
                            single-line
                          ></v-select>
                        </v-col>
                        <v-col cols="12">
                          <v-select
                            dense
                            rounded
                            outlined
                            v-model="editedItem.academicyear"
                            :items="ay_list"
                            :readonly="editedIndex == -1 ? false : true"
                            item-text="academicyear"
                            item-value="id"
                            label="Academic Year"
                            persistent-hint
                            :disabled="editedIndex != -1"
                            :hint="iseditable ? 'Academic Year' : 'noneditable'"
                            :filled="editedIndex == -1 ? false : true"
                            return-object
                            single-line
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="12">
                          <v-text-field
                            v-model="editedItem.prefixvalue"
                            label="Prefix"
                            dense
                            rounded
                            outlined
                            hint="For example :: 119S etc"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            type="number"
                            v-model="editedItem.number_of_digits"
                            label="No of Digits"
                            dense
                            rounded
                            outlined
                            hint="For example :: 4 etc"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <input
                            type="hidden"
                            v-model="editedItem.id"
                            name="id"
                          />
                          <!-- <v-hidden v-model="editedItem.id" label="id"></v-hidden> -->
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="button" @click="close">Cancel</v-btn>
                    <v-btn class="button" @click="save">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.isactive="{ item }">
            <span v-if="item.isactive">
              <v-icon small class="mr-2" color="success"
                >mdi-check-circle-outline</v-icon
              >
            </span>
            <span v-else>
              <v-icon small class="mr-2" color="error"
                >mdi-close-circle-outline</v-icon
              >
            </span>
          </template>
          <template v-slot:item.action="{ item }">
            <div>
              <v-avatar style="" size="25" class="edit-avatar">
                <v-icon class="edit-v-icon mr-2" @click="editItem(item)"
                  >edit</v-icon
                >
              </v-avatar>
            </div>
          </template>
        </v-data-table>
      </template>
    </v-app>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    overlay: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    iseditable: false,
    load: false,
    dialog: false,
    serial_field_master_list: null,
    serial_field_type_list: null,
    ay_list: null,
    search: "",
    headers: [
      { text: "Serial Field Type", value: "serialfieldtype" },
      { text: "Academic Year", value: "academicyear" },
      { text: "Prefix", value: "prefixvalue" },
      { text: "Number of Digits", align: "center", value: "number_of_digits" },
      { text: "Actions", value: "action", sortable: false },
    ],

    editedIndex: -1,
    editedItem: {
      id: 0,
      serialfieldtype: "",
      prefixvalue: "",
      number_of_digits: "",
      academicyear: "",
    },
    defaultItem: {
      id: 0,
      serialfieldtype: "",
      prefixvalue: "",
      number_of_digits: "",
      academicyear: "",
    },
    isallowed:false,
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Config" : "Edit Config";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  mounted() {
    axios
      .post("/admission/serialFieldConfig")
      .then((res) => {
        if (res.data.flag == "YES") {
          this.isallowed = res.data.isallowed;
          this.serial_field_master_list = res.data.serial_field_master_list;
          this.serial_field_type_list = res.data.serial_field_type_list;
          this.ay_list = res.data.ay_list;
          this.load = true;
        } else if (res.data.flag == "No") {
            this.isallowed = res.data.isallowed;
            this.showSnackbar("red", res.data.snackbar)
            this.load = false
        }
      })
      .catch((error) => {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        window.console.log(error);
      });
  },

  methods: {
    editItem(item) {
      this.iseditable = false;
      this.editedIndex = this.serial_field_master_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    deleteItem(item) {
      const index = this.serial_field_master_list.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.rolelist.splice(index, 1);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        //  console.log("edit.." + this.editedItem);
        this.iseditable = false;
        axios
          .post("/admission/editSerialFieldConfig", this.editedItem)
          .then((res) => {
            if (res.data.msg == "200") {
              Object.assign(
                this.serial_field_master_list[this.editedIndex],
                this.editedItem
              );
            }
            this.showSnackbar(
              "#4caf50",
              "Serial Config Updated Successfully..."
            ); // show snackbar on success
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            window.console.log(error);
          });
      } else {
        axios
          .post("/admission/saveSerialFieldConfig", this.editedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.serial_field_master_list.push(this.editedItem);
              this.showSnackbar("#4caf50", "New Config Added Successfully!!!"); // show snackbar on success
            } else if (res.data.status.code == "NA") {
              //alert(res.data.status.message)
              this.showSnackbar("#b71c1c", "Serial Config Already Present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
      }
      this.close();
    },
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
.mytable2 /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>